// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1X03-","requiredAsterisk":"Info_requiredAsterisk__3Orbh"};